import { algoliasearch } from "algoliasearch";
import aa from "search-insights";

let client: any = null;

export function getAlgoliaClient(config: {
  applicationId: string;
  searchApiKey: string;
  host?: string;
} | undefined) {
  if (!client && config) {
    client = algoliasearch(
      config.applicationId,
      config.searchApiKey,
      config.host
        ? {
          hosts: [
            {
              url: config.host,
              protocol: "https",
              accept: "read",
            },
          ],
        }
        : undefined
    );
  }

  return client;
}

let isInitialized = false;

export const initAlgoliaInsights = ({
  appId,
  apiKey,
  host,
  otherOptions,
}: {
  appId: string;
  apiKey: string;
  host?: string;
  otherOptions?: any;
}) => {
  if (isInitialized) return;

  aa("init", host ? {
    ...(otherOptions || {}),
    appId: appId,
    apiKey: apiKey,
    host: host,
  } : {
    ...(otherOptions || {}),
    appId: appId,
    apiKey: apiKey
  });

  isInitialized = true;
};